import { Injectable } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import {
  DbPersistenceService,
  Query,
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { MaterialDeliveriesDaoService } from '../material-delivery-dao.service';
import { MaterialDelivery } from 'src/app/_model/material-delivery';
import { MaterialDeliveriesDbTableDefinition } from './material-delivery-db-table-definition';

@Injectable()
export class MaterialDeliveriesDbDaoService
  implements MaterialDeliveriesDaoService
{
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private appParameter: AppParameterService,
    private materialDeliveriesTableDefinition: MaterialDeliveriesDbTableDefinition,
  ) {}

  public async saveMaterialDeliveries(
    materialDeliveries: MaterialDelivery[],
  ): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      var queries: Query[] = [];
      for (const data of materialDeliveries) {
        let query: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
            this.materialDeliveriesTableDefinition.tableName +
            '(id, label, databag, carid, carlabel, description, deliverydate)' + // 2
            ' VALUES (?,?,?,?,?,?,?)',
          parameters: [
            Number(data.getImsId()),
            data.label,
            data.databag ? JSON.stringify(data.databag) : undefined,
            data.car ? Number(data.car.getImsId()) : undefined,
            data.car ? data.car.label : undefined,
            data.description,
            data.deliverydate,
          ],
        };
        queries.push(query);
      }
      await this.dbPersistenceService.executeBatch(db, queries);
    } catch (error) {
      this.logger.log(
        'Error saving',
        this.materialDeliveriesTableDefinition.tableName,
        'to db',
        error,
        '-',
        error?.message,
      );
    }
  }

  public async getMaterialDeliveries(): Promise<MaterialDelivery[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let objects: MaterialDelivery[] = [];

      let data = await this.dbPersistenceService.executeQuery(db, {
        statement:
          'SELECT * FROM ' +
          this.materialDeliveriesTableDefinition.tableName +
          ';',
        parameters: null,
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        objects.push(
          MaterialDelivery.fromDto(
            {
              id: row['id'],
              label: row['label'],
              car: {
                id: row['carid'],
                label: row['carlabel'],
              },
              description: row['description'],
              deliverydate: row['deliverydate'],
              secondaryid: undefined,
            },
            row['databag'] ? JSON.parse(row['databag']) : undefined,
            this.appParameter.getFormatLabelForObject('ims/MaterialDelivery'),
          ),
        );
      }
      return objects;
    } catch (error) {
      this.logger.log(
        'Error reading',
        this.materialDeliveriesTableDefinition.tableName,
        'from db',
        error,
      );
    }
    return [];
  }

  public async reset() {}

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.materialDeliveriesTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.materialDeliveriesTableDefinition.tableName,
    );
  }
}
